<template>
  <nav>
    <div class="container">
      <div class="row">
        <div class="logo">
          <router-link tag="a" :to="getHomeUrl()" class="no-active"
            ><img :src="logo" alt=""
          /></router-link>
        </div>
        <div class="menu">
          <ul class="d-flex">
            <li>
              <router-link tag="a" to="/" exact>Нүүр хуудас</router-link>
            </li>
            <li v-if="bonus">
              <div class="dropdown-main">
                <span>Гүйлгээний хуулга</span>
                <div class="dropdown-content">
                  <router-link tag="a" to="/transaction" exact
                    >Бонус</router-link
                  >
                  <router-link tag="a" to="/coin" exact v-if="nomin"
                    >Койн</router-link
                  >
                  <router-link tag="a" to="/transactionJuram" exact
                    >Журмын халаас
                  </router-link>
                  <router-link tag="a" to="/transactionChild" exact
                    >Хүүхдийн карт
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="!bonus">
              <div class="dropdown-main">
                <span>Гүйлгээний хуулга</span>
                <div class="dropdown-content">
                  <router-link tag="a" to="/businessBonus" exact
                    >Гүйлгээний хуулга БИЗНЕС</router-link
                  >
                  <router-link tag="a" to="/transactionBusiness" exact
                    >Гүйлгээний хуулга Бэлтгэн</router-link
                  >
                  <router-link tag="a" to="/transactionBn" exact
                    >Гүйлгээний хуулга Гишүүнчлэл
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="dvip && bonus">
              <router-link tag="a" to="/member" exact
                >Гишүүнчлэл карт</router-link
              >
            </li>
            <li>
              <router-link tag="a" to="/service" exact
                >Үйлчилгээний нөхцөл</router-link
              >
            </li>
          </ul>
        </div>
        <div class="header-user">
          <ul>
            <li>
              <p>
                <router-link tag="a" to="/profile"
                  ><img src="@/assets/icon/user.png" alt="" />
                  {{ user.firstName }}
                </router-link>
              </p>
            </li>
            <li v-if="showQrAndExit == 'true'" @click="logout">
              <span> <img src="@/assets/icon/log_w.png" alt="" /> Гарах</span>
            </li>
          </ul>
        </div>
        <div
          class="mob-menu"
          :class="{ mobileIcon: mobileMenu }"
          @click="showMobileMenu"
        >
          <div v-if="showQrAndExit == 'true'" @click="logout" class="log-out">
            <img
              src="@/assets/icon/log_w.png"
              alt=""
              style="margin-right: 15px"
            />Гарах
          </div>
          <div class="mob-menu-icon">
            <img :src="menuLogo" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="container"
      style="margin: 0; padding: 0"
      id="mobile-menu"
      :class="{ block: showMenu }"
    >
      <div class="mobile-menu">
        <div class="mobile-menu-inner">
          <ul>
            <li><router-link tag="a" to="/" exact>Нүүр хуудас</router-link></li>
            <li>
              <router-link tag="a" to="/transaction" exact
                >Гүйлгээний хуулга</router-link
              >
            </li>
            <li v-if="nomin">
              <router-link tag="a" to="/coin" exact>Койны хуулга</router-link>
            </li>
            <li v-if="dvip">
              <router-link tag="a" to="/member" exact
                >Гишүүнчлэл карт</router-link
              >
            </li>
            <li>
              <router-link tag="a" to="/service" exact
                >Үйлчилгээний нөхцөл</router-link
              >
            </li>
            <li>
              <img
                src="@/assets/icon/user.png"
                alt=""
                style="margin-right: 10px"
              />{{ user.firstName }}
            </li>
            <li class="mobile-user-profile" v-if="isMobile">
              <router-link tag="a" to="/info" exact
                >Ерөнхий мэдээлэл</router-link
              >
            </li>
            <li class="mobile-user-profile" v-if="isMobile">
              <router-link tag="a" to="/user-edit" exact
                >Хэрэглэгчийн мэдээлэл засах</router-link
              >
            </li>
            <li class="mobile-user-profile" v-if="isMobile">
              <router-link tag="a" to="/user-password" exact
                >Нэвтрэх нууц үг солих</router-link
              >
            </li>
            <!-- <li class="mobile-user-logout" ><div @click="logout"><img src="@/assets/icon/log_w.png" alt="" style="margin-right:10px">Гарах</div></li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="box-qr" v-if="isMobile && showQrAndExit == 'true'">
      <div class="qr-image">
        <img src="@/assets/icon/myqr.png" width="80%" @click="showQrDlg" />
      </div>
    </div>

    <transition name="fade" v-if="bonus">
      <Number
        @closeNumber="closeNumber"
        v-if="checkNumber"
        :phone="user.idPhone"
        :isIdPhoneUpdated="user.isIdPhoneUpdated"
      ></Number>
    </transition>

    <transition name="fade">
      <Password
        v-if="checkPassword"
        @closePassword="closePassword"
        :password="user.isPasswordChanged"
      ></Password>
    </transition>

    <!-- Давхар баталгаажуулалт хийгдэж байгаа учир энэ кодыг хасав. 2023/03/22 -->
    <!-- <transition name="fade">
      <Validatestep1
        v-if="!validated && step == 1"
        @addStep="change"
        @sendedValue="sendedValue"
        :idPhone="user.idPhone"
        :customerEMail="user.customerEMail"
      ></Validatestep1>
      <Validatestep2
        v-if="!validated && step == 2"
        @addStep="change"
        @closeValidate="closeValidate"
        :idPhone="user.idPhone"
        :customerEMail="user.customerEMail"
        :userSendValue="userSendValue"
      ></Validatestep2>
    </transition> -->

    <transition name="fade">
      <Info v-if="infoMessage" @hideInfoMessage="hideInfoMessage"></Info>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
    <transition name="fade">
      <QrDialog
        v-if="showQr"
        @hideQr="hideQr"
        @RedirectLogin="RedirectLogin"
      ></QrDialog>
    </transition>
  </nav>
</template>

<script>
import EventBus from "@/EventBus.js";
import { Header } from "@/mixins/Header";
import Number from "@/views/number/main";
import Password from "@/views/password/main";
import Success from "@/views/plugin/success";
import Info from "@/views/plugin/info";
import QrDialog from "@/views/plugin/qrCode";
// import Validate from "@/views/password/validatestep1";
// import Validatestep1 from "../password/validatestep1.vue";
// import Validatestep2 from "../password/validatestep2.vue";
export default {
  data() {
    return {
      user: {},
      checkNumber: false,
      checkPassword: false,
      validated: true,
      nomin: false,
      dvip: false,
      mobileMenu: false,
      showMenu: false,
      logo: require("@/assets/logo.svg"),
      menuLogo: require("@/assets/icon/menu-w.png"),
      windowWidth: 0,
      windowHeight: 0,
      successMessage: "",
      successModal: false,
      infoMessage: false,
      showQr: false,
      isMobile: false,
      showQrAndExit: "true",
      bonus: false,
      userData: {},
      step: 1,
      userSendValue: "",
    };
  },
  mixins: [Header],
  mounted() {
    //hide mobile menu when page loaded
    EventBus.$on("MOBILE_MENU_HIDE", (data) => {
      this.showMenu = false;
      this.mobileMenu = false;
      if (this.mobileMenu == true) {
        this.menuLogo = require("@/assets/icon/menu-b.png");
      } else {
        this.menuLogo = require("@/assets/icon/menu-w.png");
      }
    });
  },
  methods: {
    closeValidate() {
      this.validated = true;
    },
    getHomeUrl() {
      return "/";
      // return this.nomin ? "/" : "/transaction";
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    closeNumber() {
      this.checkNumber = false;
    },
    closePassword() {
      this.checkPassword = false;
      this.successMessage = "Амжилттай хадгаллаа ";
      this.successModal = true;
    },
    hideInfoMessage() {
      this.infoMessage = false;
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth <= 1000) {
        this.logo = require("@/assets/icon/mobile-logo.png");
      } else {
        this.logo = require("@/assets/logo.svg");
      }
    },
    isDesktop() {
      if (device.mobile()) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    hideQr() {
      this.showQr = false;
    },
    //change step
    change() {
      this.step++;
    },
    //sendedvalue
    sendedValue(value) {
      this.userSendValue = value;
    },
    showQrDlg() {
      this.showQr = true;
    },
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
    },
  },

  created() {
    this.isDesktop();
    this.getUser();
    this.getWindowWidth();
    this.cardInfoList();
    // console.log(this.$auth.getShowQR(),'this.$auth.getShowQR()');
    if (this.$auth.getShowQR()) {
      this.showQrAndExit = this.$auth.getShowQR();
    }

    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  components: {
    Number,
    Password,
    Success,
    Info,
    QrDialog,
    // Validate,
    // Validatestep1,
    // Validatestep2,
  },
};
</script>

<style>
.qr-image {
  width: 100%;
  justify-content: center;
  display: flex;
}
.box-qr {
  margin-bottom: 10px;
  background-color: white;
  border: 1px solid #e9ecef;
  padding: 10px 5px;
  position: fixed;
  bottom: 15px;
  left: 25px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  z-index: 999;
  box-shadow: 1px 1px 14px 1px rgb(22 96 171);
}
.qr-image img {
  width: 40px;
  height: 40px;
}
nav {
  background: #fff;
  color: #333333;
  height: 50px;
  box-shadow: 0px 3px 3px 0 rgba(0, 0, 0, 0.05);
  position: fixed;
  width: 100%;
  top: 0;
  margin: 0 auto;
  left: 0px;
  right: 0px;
  z-index: 3;
}

#footer {
  margin-top: 20px;
  padding: 10px 10px;
}
.menu .router-link-active {
  border-bottom: 2px solid red;
}
.header-user .router-link-active {
  border-bottom: 2px solid red;
}
.no-active {
  border-bottom: 0px !important;
}
.mtop10 {
  margin-top: 30px;
}
a {
  text-decoration: none !important;
}
nav .row {
  height: 50px;
  padding-left: 15px;
  padding-right: 15px;
}
nav .menu ul li {
  height: 100%;
  font-size: 13px;
  transition: all 0.2s ease-in-out;
  display: block;
  text-align: center;
  list-style: none;
  cursor: pointer;
  color: #333333;
}
nav .menu ul li a {
  color: #000000;
  font-size: 14px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

nav .menu ul {
  height: 100%;
  padding: 0;
  align-items: center;
  justify-content: center;
}
nav .menu {
  width: 50%;
}
.header-user {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 30%;
}
.header-user ul {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
}
.header-user ul li {
  display: flex;
}
.header-user p {
  padding: 0;
  margin: 0;
  display: flex;
  margin-right: 7%;
  font-size: 13px;
}
.menu ul {
  justify-content: flex-start;
}
.menu ul li:nth-child(2) {
  margin-left: 30px;
}
.menu ul li:nth-child(3) {
  margin-left: 30px;
}
.menu ul li:nth-child(4) {
  margin-left: 30px;
}
.header-user p a {
  text-transform: capitalize;
  font-size: 14px;
  padding: 0px 15px 0px 15px;
  text-align: right;
  color: inherit;
  display: flex;
  align-items: center;
}
.header-user p a img {
  margin-right: 3px;
}
.header-user p i {
  margin-right: 8px;
}
.header-user ul li:nth-child(1) {
  height: 100%;
  flex: 3;
  display: flex;
  justify-content: flex-end;
}
.header-user ul li:nth-child(2) {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
}
.header-user ul li:nth-child(2) span {
  background: #ed3237;
  width: 100px;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  padding: 10px 15px 10px 15px;
  transition: all 0.1s ease-in;
  cursor: pointer;
  text-align: center;
}
.header-user span i {
  margin-right: 4px;
}
.header-user span:hover {
  background: #1f71c4;
  color: #fff;
}
.logo {
  display: flex;
  align-items: center;
  width: 20%;
}
.logo img {
  width: 100%;
}
.mob-menu {
  display: none;
}
#mobile-menu {
  display: none;
}
.log-out {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 30px;
  border-radius: 5px;
  /* background-color: #1660ab; */
  color: #fff;
  font-size: 14px;
  position: absolute;
  right: 70px;
  top: 14px;
}
@media only screen and (max-width: 500px) {
  .logo img {
    padding-right: 20px;
    width: 75px;
    padding-left: 20px;
  }
  nav .row {
    padding-left: 0;
    padding-right: 0;
  }
}

@media screen and (max-width: 1024px) and (min-width: 501px) {
  .logo img {
    padding-right: 20px;
    width: 55px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  nav {
    height: 55px;
  }
  nav .row {
    height: 55px;
  }
  .main-wrapper {
    background: #f2f2f2 !important;
  }

  nav {
    background: #1660ab;
  }
  .menu,
  .header-user {
    display: none;
  }
  .logo {
    width: 80%;
  }
  .mob-menu {
    /* width: 20% !important; */
    display: block;
    cursor: pointer;
    right: 0;
    position: absolute;
  }
  .mob-menu-icon {
    height: 100%;
    color: #fff;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
  }
  #footer {
    margin-top: 40px;
  }
  .pagination {
    margin-top: 40px !important;
  }
}
@media (min-width: 300px) and (max-width: 767px) {
  .log-out {
    right: 65px;
  }
  nav {
    height: 55px;
  }
  nav .row {
    height: 55px;
  }
  .main-wrapper {
    background: #f2f2f2 !important;
  }

  nav {
    background: #1660ab;
  }
  .menu,
  .header-user {
    display: none;
  }
  .logo {
    width: 80%;
  }
  .mob-menu {
    width: 20% !important;
    display: block;
    cursor: pointer;
  }
  .mob-menu-icon {
    height: 100%;
    color: #fff;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #footer {
    margin-top: 40px;
  }
  .pagination {
    margin-top: 40px !important;
  }
}

.mobile-menu {
  background-color: rgba(0, 0, 0, 0.05);
  width: 100%;
  position: fixed;
  min-height: 100%;
  z-index: 40;
}
.mobile-menu-inner {
  background-color: rgba(255, 255, 255, 1);
  height: auto;
  padding-bottom: 100px;
}
.mobile-menu-inner ul {
  margin-left: 0;
  padding: 0;
  margin-bottom: 20px;
}
.mobile-menu-inner ul li {
  height: 66px;
  padding-left: 40px;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 4.27;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  color: #000000;
  border-bottom: 1px solid #ebebeb;
}
.mobile-menu-inner ul li:last-child {
  border-bottom: 0;
  /* padding-top: 30px; */
}
.mobile-menu-inner ul li a {
  color: inherit;
  font-size: 15px;
}
.mobile-menu-inner ul li i {
  margin-right: 8px;
}
.mobile-menu-inner .mobile-user-profile a {
  margin-left: 31px;
}

.mobile-menu-inner .mobile-user-logout div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 144px;
  height: 40px;
  border-radius: 10px;
  background-color: #1660ab;
  color: #fff;
  font-size: 15px;
}
.mobileIcon {
  transition: all 0.3s ease-in-out;
  background: #fff;
}
.mobileIcon i {
  color: #1660ab;
}
</style>
